module.exports = __webpack_public_path__ + "static/media/logo-celebrity.9233c90e.png";